export const COLLECTION_SETTINGS = {
  PROGRAM_SESSION_DURATION: [
    { value: '<30', name: '<30 min' },
    { value: '30-45', name: '30-45 min' },
    { value: '45-60', name: '45-60 min' },
    { value: '60-90', name: '60-90 min' },
    { value: '>90', name: '>90 min' },
  ],
  PROGRAM_GOALS: [
    'Weight Loss',
    'Gain Muscle',
    'Lean Muscle',
    'Strength',
    'Conditioning',
    'Toning',
    'Shredding',
    'Recovery',
    'Athletic Performance',
    'Skills Training',
    'Flexibility',
    'Mobility',
    'Endurance',
    'Mindfulness',
    'Progression',
  ],
  COLLECTION_TAGS: [
    'Yoga',
    'Pilates',
    'Barre',
    'HIIT',
    'Cardio',
    'Cycling',
    'Crossfit',
    'Running',
    'Meditation',
    'Boxing',
    'Prenatal',
    'Postnatal',
    'Bodyweight',
    'Bodybuilding',

    'Calisthenics',
    'Tabata',
    'Sports',
    'Bikini Body',
    'Dance',
    'Warm Up',
    'Stretching',
    'Kettlebell',
    'Functional',
    'Weight lifting',
  ],
  COLLECTION_TARGET_AREA: [
    'Arms',
    'Back',
    'Biceps',
    'Chest',
    'Core/Abs',
    'Full Body',
    'Glutes',
    'Legs',
    'Lower Body',
    'Shoulders',
    'Triceps',
    'Upper Body',
    'Other',
  ],
  COLLECTION_LOCATION: [
    { value: 'Home', name: 'Home' },
    { value: 'Gym', name: 'Gym' },
    { value: 'Outdoor', name: 'Outdoor' },
  ],
  COLLECTION_DIFFICULTY: [
    { value: 'All Levels', name: 'All Levels' },
    { value: 'Beginner', name: 'Beginner' },
    { value: 'Intermediate', name: 'Intermediate' },
    { value: 'Advanced', name: 'Advanced' },
  ],
  PROGRAM_FAQ_SUGGESTIONS: [
    // NOTE: taken from https://docs.google.com/document/d/1MvCb7Ayhqs8tUOf8FQ6jZJXaXRvktvnTDY22M3Rib08/edit
    {
      question: `What are the goals of this program?`,
      answer: `* Increase overall lean muscle mass
* Get lean and burn fat
* Build core strength
* Improve posture
* Improve mental clarity and focus`,
    },
    {
      question: `What do I need to participate?`,
      answer: `* You need a gym membership that has standard workout equipment
* A positive attitude and dedication to the program`,
    },
    {
      question: `Who are these workouts for (skill-level)?`,
      answer: `* The workouts are designed for all levels
* Beginners: go slow, use less weight, use longer rest periods, and focus on form
* Advanced: increase weight, reps and reduce rest time as you progress`,
    },
    {
      question: `What’s the schedule?`,
      answer: `* Weight training 3-4 times per week
* 2 days of active rest: When you rest from lifting, you should still remain active. Do HIIT cardio/ab workouts, play sports, go for a hike or a long walk
* 1 full rest day`,
    },
    {
      question: `How will I get the best results?`,
      answer: `* Get proper sleep (7-9 hours a night is a must)
* Dedicated nutrition regimen that consists only of wholesome, natural ingredients (get my nutrition guide in “Insights” section of the app)
* Drink at least eight 8 oz glasses of water daily
* Make sure to use active and full rest days to allow muscles to recover
* Ice cold showers in the morning and after workouts are highly recommended`,
    },
    {
      question: `Are there any modifications for the exercises?`,
      answer: `* Yes! I’ve included modifications in the descriptions for each exercise. If you need further assistance modifying any workouts, send me a message in the app and I’ll be happy to help!`,
    },
    {
      question: `How can I ask you questions?`,
      answer: `Message me in the app for any questions you have. I do my best to review all comments and make any recommended changes.

I want to see your progress!

I would also love to see your progress pictures and videos. Tag me on Instagram and use the hashtag [INSERT HASHTAG HERE] or feel free to shoot me a DM on IG. I would love to showcase your progress to our community.
    `,
    },
  ],
};
